export default function Pagination({
  page, lastPage, total, perPage, onChange,
}: {
  page: number;
  lastPage: number;
  total: number;
  perPage: number;
  onChange: (p: number) => void;
}) {
  const from = (page - 1) * perPage + 1;
  const to = Math.min(page * perPage, total);

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
      <span className="muted">
        {from.toLocaleString()}–{to.toLocaleString()} of {total.toLocaleString()}
      </span>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <button className="secondary" disabled={page <= 1} onClick={() => onChange(page - 1)}>Prev</button>
        <span className="muted">Page {page} / {lastPage}</span>
        <button className="secondary" disabled={page >= lastPage} onClick={() => onChange(page + 1)}>Next</button>
      </div>
    </div>
  );
}
